class NewsletterPopup {
  constructor(element) {
    this.element = element;
    this.showAfter = element.dataset.time;
    this.closeFor = element.dataset.closeFor;
    this.closeButtons = document.querySelectorAll('[data-dismiss="modal"]');
    this.cookie = this.getCookie('newsletterPopup');
    this.closePopup();
    this.showPopup();
  }

  closePopup() {
    this.closeButtons.forEach(items => {
      items.addEventListener('click', () => {
        document.querySelector('.newsletter-modal').style.display = 'none';
        this.setCookie("newsletterPopup", "no", this.closeFor * 1);
        document.body.classList.remove('overflow--hidden');
      })
    })
  }

  showPopup() {
    if(this.cookie == null) {
      setTimeout(() => {
        this.element.style.display = 'flex';
        document.body.classList.add('overflow--hidden');
      }, this.showAfter * 1000)
    }
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 60 * 1000)); // Multiply minutes by 60,000 to convert to milliseconds
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
}

new NewsletterPopup(document.querySelector('.js-newsletterPopup'));